import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tabs, Tab } from 'material-ui/Tabs';
import _ from 'lodash';

import { NitroHeading, NitroLoading, NitroPanel } from 'nitro-components';

import DisableCover from '@src/components/libs/disabled';

import AdminAPI from '../../../api/AdminApi';
import AddNewCompanyCode from './restrictions/AddNewCompanyCode';
import CompanyCodesContainer from './restrictions/CompanyCodesContainer';
import SimpleError from "@src/features/errors/SimpleError";

const Container = styled.div`
  width: 98% !important;
  height: auto !important;
`;

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  height: auto !important;
`;

class UserRestrictions extends Component {
  static propTypes = {
    availableCountries: PropTypes.arrayOf(PropTypes.string).isRequired,
    businessEntityId: PropTypes.number.isRequired,
    userid: PropTypes.string.isRequired,
    setRestrictionAction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      AllocatedRestrictions: [],
      isLoading: false,
      isLimited: false
    };
  }

  componentWillMount() {
    if (this.props.userid && this.props.userid !== 'new')
      this.getUserRestrictions(this.props.userid);
  }

  componentDidMount() {
    this.templateCompanyCode = {
      companyCode: '',
      companyName: '',
      countryCode: '',
      isEmployer: false,
      // restrictions: [
      //   {
      //     typeId: 1,
      //     typeName: 'Cost Centre',
      //     options: null,
      //     values: [],
      //   },
      //   {
      //     typeId: 2,
      //     typeName: 'Division',
      //     options: null,
      //     values: [],
      //   },
      //   {
      //     typeId: 3,
      //     typeName: 'State',
      //     options: null,
      //     values: [],
      //   },
      //   {
      //     typeId: 5,
      //     typeName: 'Lease Type',
      //     options: null,
      //     values: [],
      //   },
      //   {
      //     typeId: 4,
      //     typeName: 'Classification',
      //     options: null,
      //     values: [],
      //   }
      // ],
    };

    this.NewCompanyCodesAU = [];
    this.NewCompanyCodesNZ = [];
    this.deletedCostCentres = [];
  }

  syncChanges = () => {
    const { AllocatedRestrictions } = this.state;
    this.props.setRestrictionAction(AllocatedRestrictions);

    if (AllocatedRestrictions.length >= 5) {
      this.setState({ isLimited: true })

    } else {
      this.setState({ isLimited: false })
    }
  };

  getUserRestrictions = userid => {
    this.setLoading(true);
    AdminAPI.getUserRestrictions(userid).then(response => {

      this.setState(
        {
          AllocatedRestrictions: response,
          isLoading: false,
        },
        () => this.syncChanges()
      );
    });
  };

  getValue() {
    return this.state.AllocatedRestrictions;
  }

  setLoading = status => {
    this.setState({
      isLoading: status,
    });
  };

  GetOptions(data, typeId) {
    this.GetOptions = 'GetOptions';
    let optionsType = [];
    data.map(e => {
      if (e.typeId === typeId) optionsType = e.options;
      return {};
    });

    return optionsType;
  }

  changeHandler = (typeId, values, company, country, AllocatedRestrictions) => {
    // check if AllocatedRestriction has data

    this.AllocatedRestrictions = this.state.AllocatedRestrictions;

    const AllocatedRestrictionsCloned = _.clone(this.AllocatedRestrictions);

    // Get the restrictions.

    AllocatedRestrictionsCloned.forEach(UserCompanyCode => {
      if (
        UserCompanyCode.countryCode === country &&
        UserCompanyCode.companyCode === company
      ) {
        UserCompanyCode.restrictions.map(restrict => {
          if (restrict.typeId === typeId) {
            restrict.values = values;
          }
        });
      }
      return {};
    });

    this.AllocatedRestrictions = AllocatedRestrictionsCloned;
    this.setState(
      {
        AllocatedRestrictions: this.AllocatedRestrictions,
      },
      () => this.syncChanges()
    );
  };

  AddDeleteCompanyCode(values, tabValue) {
    // const countryCode = tabValue === 'Australia' ? 'AU' : 'NZ';
    const { countryCode } = this.state;

    const newCompanyCode = [];
    values.forEach(element => {
      const newCompany = _.clone(this.templateCompanyCode);
      newCompany.companyCode = element.CompanyCode;
      newCompany.companyName = element.CompanyName;
      newCompany.countryCode = countryCode;
      newCompanyCode.push(newCompany);
    });
    if (countryCode === 'AU') {
      this.NewCompanyCodesAU = newCompanyCode;
      this.AllocatedRestrictions = [
        ...this.state.AllocatedRestrictions,
        ...this.NewCompanyCodesAU,
      ];
    } else {
      this.NewCompanyCodesNZ = newCompanyCode;
      this.AllocatedRestrictions = [
        ...this.state.AllocatedRestrictions,
        ...this.NewCompanyCodesNZ,
      ];
    }
    this.setState(
      {
        AllocatedRestrictions: this.AllocatedRestrictions,
      },
      () => this.syncChanges()
    );
  }

  removeCostCentre = (data, allocatedRestrictions) => {
    this.deleteAwaited = data;
    this.deleteCostCentre(data, allocatedRestrictions);
  };

  deleteCostCentre = (data, allocatedRestrictions) => {
    const companyCode = data.companyCode;
    const countryCode = data.countryCode;

    this.deletedCostCentres.push({
      companyCode,
      countryCode,
    });
    const tempAllocatedRestriction = [];
    this.AllocatedRestrictions = allocatedRestrictions;
    this.AllocatedRestrictions.forEach(element => {
      if (
        !(
          element.countryCode === countryCode &&
          element.companyCode === companyCode
        )
      ) {
        tempAllocatedRestriction.push(element);
      }
    });
    this.AllocatedRestrictions = tempAllocatedRestriction;
    this.setState(
      {
        // showModal: false,
        AllocatedRestrictions: this.AllocatedRestrictions,
      },
      () => this.syncChanges()
    );
    this.deleteAwaited = [];
  };

  AddCompanyCode = restrictions => {
    // check if company code with country exists...
    const flag = this.state.AllocatedRestrictions.some(
      e =>
        e.companyCode === restrictions.companyCode &&
        e.countryCode === restrictions.countryCode
    );
    if (!flag) {
      this.setState(
        {
          AllocatedRestrictions: [
            ...this.state.AllocatedRestrictions,
            {
              companyCode: restrictions.companyCode,
              companyName: restrictions.companyName,
              countryCode: restrictions.countryCode,
              isEmployer: restrictions.isEmployer,
              restrictions: restrictions.restrictions,
            },
          ],
        },
        () => this.syncChanges()
      );
    }
  };

  render() {
    const { isLoading } = this.state;
    const { businessEntityId } = this.props;

    const countriesForTabs = this.props.availableCountries.reduce(
      (a, t) => ({ ...a, [t.toLowerCase()]: t.toLowerCase() }),
      {}
    );

    if (businessEntityId <= 0) {
      return null;
    }

    return (
      <NitroPanel>
        {isLoading && (
          <div>
            <DisableCover />
            <NitroLoading center screen />
          </div>
        )}

        <NitroHeading label="User Restrictions" size="1" variant="secondary" />
        <Container>
          <Tabs>
            {countriesForTabs.au ? (
              <Tab value="Australia" label="Australia">
                <div>
                  <CompanyCodesContainer
                    allocatedRestrictions={this.state.AllocatedRestrictions}
                    countryCode="AU"
                    companycode={this.props.companycode}
                    businessEntityId={this.props.businessEntityId}
                    onChangeRestriction={this.changeHandler}
                    onRemoveCostCentre={this.removeCostCentre}
                    userid={this.props.userid}
                  />{' '}
                  {!this.state.isLimited && <AddNewCompanyCode
                    countryCode="AU"
                    AddCompanyCode={this.AddCompanyCode}
                    businessEntityId={this.props.businessEntityId}
                  />}
                  {this.state.isLimited && <SimpleError
                    headindText={"Search Limit Error"}
                    messageDetail={"You have reached the maximum number of cross-companies"}
                  />}
                </div>
              </Tab>
            ) : null}
            {countriesForTabs.nz ? (
              <Tab value="New Zealand" label="New Zealand">
                <div>
                  <CompanyCodesContainer
                    allocatedRestrictions={this.state.AllocatedRestrictions}
                    countryCode="NZ"
                    companycode={this.props.companycode}
                    businessEntityId={this.props.businessEntityId}
                    onChangeRestriction={this.changeHandler}
                    onRemoveCostCentre={this.removeCostCentre}
                    userid={this.props.userid}
                  />{' '}
                  {!this.state.isLimited && <AddNewCompanyCode
                    countryCode="NZ"
                    AddCompanyCode={this.AddCompanyCode}
                    businessEntityId={this.props.businessEntityId}
                  />}
                  {this.state.isLimited && <SimpleError
                    headindText={"Search Limit Error"}
                    messageDetail={"You have reached the maximum number of cross-companies"}
                  />}
                </div>
              </Tab>
            ) : null}
          </Tabs>
        </Container>
      </NitroPanel>
    );
  }
}

export default connect(
  null,
  null,
  null,
  { withRef: true }
)(UserRestrictions);



// WEBPACK FOOTER //
// ./src/features/admin/components/UserRestrictions.js